<template>
  <div>
    <v-card
      :loading="loading"
      flat
      class="mb-6"
      color="#ceeaff"
      bordered
      style="border: 1px solid #8eadc5"
      ><div class="text-h4 mx-4 mt-4">Exam and Procedure Codes</div>
      <v-card-subtitle> E/M Codes, CPT Codes, &amp; Modifiers</v-card-subtitle>
      <!-- <v-divider></v-divider> -->
    </v-card>
    <!--  -->

    <div v-if="loading" class="d-flex flex-row flex-wrap width100p">
      <v-skeleton-loader
        type="card-heading"
        style="width: 100%; height: 40px"
      ></v-skeleton-loader>

      <div
        v-for="num in 20"
        :key="num"
        class="ma-2"
        :class="$vuetify.breakpoint.mdAndUp ? 'cardWidth' : 'width98'"
      >
        <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
      </div>
    </div>

    <div v-else-if="codes && meta">
      <div
        v-for="(sectionIndexes, typeKey) in meta.sectionsByType"
        :key="typeKey"
        class="mb-10"
      >
        <!-- <v-divider></v-divider> -->
        <div class="typeDiv justify-center">
          <div
            class="text-h6 text-sm-h5 d-flex align-start px-4 my-3"
            :id="typeKey.toLowerCase()"
          >
            <!-- <v-img
              :src="iconSrc + typeKey.toLowerCase() + '_icon.svg'"
              max-width="40"
              contain
            ></v-img> -->
            {{ typeTitle[typeKey] | titleize }}
            <v-spacer v-if="isMobile"></v-spacer>
            <v-btn
              text
              small
              color="primary"
              @click="toggleExpandAll(typeKey)"
              v-if="isMobile"
            >
              <span v-if="$vuetify.breakpoint.name == 'sm'">
                {{ expandAll[typeKey] ? "Collapse" : "Expand" }} All
              </span>
              <v-icon small color="primary" class="ml-2"
                >mdi-arrow-{{
                  expandAll[typeKey] ? "collapse" : "expand"
                }}</v-icon
              ></v-btn
            >
          </div>
          <!-- <v-divider></v-divider> -->
          <div class="d-sm-flex flex-row flex-wrap">
            <div
              v-for="sectionIndex in sectionIndexes"
              :key="'si' + sectionIndex"
              :class="$vuetify.breakpoint.mdAndUp ? 'cardWidth' : 'width98'"
            >
              <!-- {{ typeKey }}-{{ sectionIndex }} -->
              <v-card
                class="mx-2 mx-sm-3 my-md-4 sectionCard"
                flat
                bordered
                :id="sections[sectionIndex].tag"
              >
                <div
                  class="cardTitle text-sm-center d-flex flex-row align-center"
                  @click="toggleShowSection(sectionIndex)"
                  :class="{ pointer: isMobile }"
                >
                  <div :class="isMobile ? 'sectionImg_sm' : 'sectionImg'">
                    <img
                      v-if="sections[sectionIndex].image"
                      :src="imgSrc + sections[sectionIndex].image"
                      contain
                      :class="isMobile ? 'sectionImg_sm' : 'sectionImg'"
                      style="border: 1px solid #a2d7ff"
                    />
                  </div>
                  <div
                    class="text-sm-h5 darkerCardText py-2 pl-4"
                    :class="{ size1em: isMobile }"
                  >
                    {{ sections[sectionIndex].name }}
                  </div>
                  <v-spacer></v-spacer>

                  <v-btn icon v-if="isMobile"
                    ><v-icon
                      >mdi-chevron-{{
                        showSection[sectionIndex] ? "up" : "down"
                      }}</v-icon
                    ></v-btn
                  >
                  <!-- <div v-if="show[`${typeKey}_${sectionIndex}`]">
                
                </div> -->
                </div>
                <v-expand-transition>
                  <v-card-text
                    class="darkerCardText pa-2"
                    v-if="
                      showSection[sectionIndex] || !isMobile || hadSearchItem
                    "
                  >
                    <table class="width100p">
                      <tr
                        v-for="codeIndex in meta.codesBySection[
                          sections[sectionIndex].tag
                        ]"
                        :key="'ci' + codeIndex"
                      >
                        <td
                          class="codeTd"
                          @click="showModifiers(codes[codeIndex].code)"
                        >
                          <vue-markdown class="mdText">
                            {{
                              processCode(codes[codeIndex].code)
                            }}</vue-markdown
                          >

                          <v-tooltip bottom v-if="codes[codeIndex].ir == 1">
                            <template v-slot:activator="{ on, attrs }">
                              <div
                                v-bind="attrs"
                                v-on="on"
                                style="color: red"
                                class="font-weight-bold ml-2"
                              >
                                (IR)
                              </div>
                            </template>
                            <span>Requires Interpretation &amp; Report</span>
                          </v-tooltip>
                        </td>
                        <td>
                          <div
                            class="font-weight-bold"
                            :style="
                              'color:' + titleColor(codes[codeIndex].title)
                            "
                          >
                            {{ codes[codeIndex].title }}
                          </div>
                          <div @click="showModifiers(codes[codeIndex].notes)">
                            <vue-markdown class="mdText">{{
                              processText(codes[codeIndex].notes)
                            }}</vue-markdown>
                          </div>
                        </td>
                      </tr>
                    </table>
                    <v-card-text
                      class="mdText"
                      @click="showModifiers(sections[sectionIndex].notes)"
                    >
                      <vue-markdown>{{
                        processText(sections[sectionIndex].notes)
                      }}</vue-markdown>
                      <div v-if="sections[sectionIndex].files" class="mt-1">
                        <div class="overline">See Also</div>
                        <pdf-viewer
                          v-for="file in sections[sectionIndex].files"
                          :key="file"
                          :url="pdfPath + file.file"
                          backBtnLabel="Back to Coding Examples"
                          ><div class="linkLike">
                            <v-icon color="primary" class="mr-2"
                              >mdi-file-pdf-box</v-icon
                            >{{ file.name }}
                          </div>
                        </pdf-viewer>
                      </div>
                    </v-card-text>
                  </v-card-text>
                </v-expand-transition>
              </v-card>
            </div>
          </div>
        </div>
      </div>
      <div class="text-h6 text-sm-h5 d-flex px-4" id="modifiers">Modifiers</div>
      <v-divider></v-divider>
      <billing-modifiers
        class="mt-2"
        :modifiers="modifiers"
        :modifiersByGroup="meta.modifiersByGroup"
      ></billing-modifiers>
    </div>

    <v-dialog v-model="modifierDialog" scrollable max-width="350">
      <v-card>
        <v-card-title
          class="text-h5 px-4 d-flex flex-row justify-space-between dialogTitle"
        >
          <div>Modifiers</div>
          <v-btn icon @click="modifierDialog = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>

        <v-card-text v-if="modifiers">
          <billing-modifiers
            :modifiers="modifiers"
            :modifiersByGroup="meta.modifiersByGroup"
            :filterFor="clickedModifiers"
          ></billing-modifiers>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- <p>{{ codes }}</p> -->
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
import VueMarkdown from "@adapttive/vue-markdown";
import BillingModifiers from "@/components/icdStuff/BillingModifiers.vue";
import FiltersMixin from "@/assets/js/cls/FiltersMixin.js";

// import Name from "../dir/file";

export default {
  name: "BillingCodes",
  components: {
    VueMarkdown,
    BillingModifiers,
    PdfViewer: () => import("@/components/universalStuff/PdfViewer.vue"),
  },
  mixins: [FiltersMixin],
  props: {},
  data: function () {
    return {
      loading: false,
      codes: null,
      sections: null,
      modifiers: null,
      modifierDialog: false,
      clickedModifiers: [],
      filters: { item: null, category: null, code: null },
      meta: null,
      imgSrc: "https://www.eyedock.com/images/billingCodes/",
      iconSrc: "https://www.eyedock.com/images/menu_icons/",
      pdfPath: "https://www.eyedock.com/images/billingCodes/medicarePDFs/",
      typeTitle: {
        EM: "E/M Codes (Evaluation & Management)",
        CPT: "CPT Codes (Procedures)",
      },
      showSection: null,
      expandAll: { EM: false, CPT: false },
      // hide: { EM: [], CPT: [], modifiers: [] },
    };
  },
  methods: {
    callApi() {
      this.loading = true;

      ApiServices.genericApiCall("/billing/all")
        .then((response) => {
          let data = response.data;
          this.codes = data.codes;
          this.sections = data.sections;
          this.modifiers = data.modifiers;
          this.meta = data.meta;
          this.populateShowData();
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {
          this.loading = false;
          this.checkForSlug();
        });
    },

    populateShowData() {
      let secs = this.sections;
      if (!secs) return;
      let show = this.$vuetify.breakpoint.smAndUp;
      let rtn = Array(secs.length).fill(show);
      this.showSection = rtn;
    },
    toggleShowSection(index) {
      // console.log(index, this.showSection[index]);
      // this.showSection[index] = !this.showSection[index];
      // this.set(this.showSection, index, !this.showSection[index]);
      this.showSection[index] = !this.showSection[index];
      this.showSection = [...this.showSection];
    },
    toggleExpandAll(type) {
      // type is EM or CPT
      let show = (this.expandAll[type] = !this.expandAll[type]);
      let ss = this.showSection;
      this.meta.sectionsByType[type].forEach((idx) => {
        ss[idx] = show;
      });
      this.showSection = [...ss];
    },
    titleColor(content) {
      return content.toLowerCase().includes("established") ? "blue" : "green";
    },
    processText(txt) {
      if (!txt) return null;
      txt = txt.replace(
        /([A-Z0-9]\d\d\d[A-Z0-9])/gim,
        "<span class='codeClass' id='code_$1'>$1</span>"
      );
      txt = txt.replace(
        /[ (/](-[A-Z0-9]{2}(?!\d))/gim,
        "<span class='modClass'> $1</span>"
      );
      return txt;
    },
    processCode(txt) {
      if (!txt) return null;
      txt = txt.trim();
      txt = txt.replaceAll(",", "<br>");
      txt = this.processText(txt);
      return txt;
    },

    hasModifiers(txt) {
      let rtn = [];
      txt.match(/[ (/](-[A-Z0-9]{2}(?!\d))/gm).forEach((element) => {
        const cleaned = element.trim().replace(/[^A-Z0-9]+/gi, "");
        rtn.push(cleaned);
      });
      return rtn;
    },
    showModifiers(txt) {
      let hm = this.hasModifiers(txt);
      console.log(hm);
      if (hm && hm.length) {
        this.modifierDialog = true;
        this.clickedModifiers = hm;
      } else {
        this.clickedModifiers = [];
      }
    },
    checkForSlug() {
      let id = null;
      let category = this.filters.category;
      let item = this.filters.item;
      let code = this.filters.code;
      // console.log(item, category);
      if (category) id = category;
      if (item) id = item;
      if (code) id = "code_" + code;
      if (id) {
        this.goToId(id);
        if (item) this.showSectionWithTag(id);
      }
    },
    goToId(id) {
      // this.goToId = id;
      this.$nextTick(() => {
        this.$vuetify.goTo("#" + id, { offset: 20 });
      });
    },
    showSectionWithTag(tag) {
      let that = this;
      this.sections.forEach((row, i) => {
        // console.log(i, row.tag);
        if (row.tag == tag) that.showSection[i] = true;
      });
    },

    // todo - put this in filtersMixin..?
    setCategoryStore(category, item) {
      this.$store.dispatch("setModeAndDetail", {
        mode: category,
        detail: item,
      });
    },
  },
  computed: {
    filteredTypes: function () {
      let rtn = this.meta?.sectionsByType;
      return rtn;
    },
    filteredCodes: function () {
      if (!this.codes) return null;
      return [];
    },
    filteredSections: function () {
      return this.meta?.codesBySection;
    },
    isMobile: function () {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
    storeDetail: function () {
      return this.$store.state.detail;
    },
    // was something passed to this page via the url? If so, expand all sections (otherwise it scrolls to a collpased item and you can't see it)
    hadSearchItem: function () {
      return this.filters.item || this.filters.category || this.filters.code;
    },
  },
  watch: {
    storeDetail(val) {
      this.filters.detail = val;
      if (val) {
        this.updateHashWithParamString("detail=" + val);
        this.goToId(val);
      } //   console.log(val);
    },
  },
  mounted() {
    this.prepend_F = false; // (for FiltersMixin)
    this.keysCase = "lower"; // (for FiltersMixin)
    let hashCat = this.hashValForKey("category");
    let hashItem = this.hashValForKey("item");
    let hashCode = this.hashValForKey("code");
    this.filters.item = hashItem;
    this.filters.category = hashCat;
    this.filters.code = hashCode;
    if (hashCat || hashItem) this.setCategoryStore(hashCat, hashItem);
    this.callApi();
  },

  metaInfo() {
    return {
      title: "EyeDock/Coding | Billing Codes",
    };
  },
};
</script>

<style scoped>
.sectionCard {
  border: 1px solid #bcbcbc !important;
}
.cardWidth {
  /* max-width: 50%;
  min-width: 350px; */
  width: 100%;
}
.width98 {
  width: 98%;
}
th,
td {
  vertical-align: top;
  padding: 4px 8px 0;
  border: 1px solid #e0e0e0;
}
.codeTd {
  /* max-width: 100px; */
  /* text-align: center; */
  width: 120px;
  font-weight: bold;
}
tr:nth-child(odd) {
  background-color: #f3faff;
}
.sectionImg {
  width: 150px;
  max-height: 50px;
  /* border: 1px solid #a2d7ff; */
}
.sectionImg_sm {
  width: 90px;
  max-height: 30px;
  /* border: 1px solid #a2d7ff; */
}
.typeTitle {
  background-color: #ceeaff;
  border: 1px solid #bcbcbc;
  padding: 5px 10px;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
}
.typeDiv {
  background-color: #f8fcff;
  border: 1px solid #bcbcbc;
  border-radius: 5px;
}
.cardTitle {
  background-color: #e8f5ff;
  border-bottom: 1px solid #bcbcbc !important;
}
table {
  border-collapse: collapse;
  background-color: #fff;
}
.mdText >>> .codeClass {
  color: purple;
  font-weight: bold;
}

.mdText >>> .modClass {
  color: rgb(128, 102, 0);
  /* padding: 1px; */
  margin: 0 2px;
  border-bottom: 1px dashed rgb(128, 102, 0);
  font-weight: bold;
  cursor: pointer;
}
.mdText >>> p {
  margin: 0;
}
.yellowBkg {
  background-color: yellow;
}
.dialogTitle {
  background-color: #ffd588;
}
.size1em {
  font-size: 1rem !important;
}
</style>
